var React = require('react');

function LogOut (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_38599","data-name":"Rectangle 38599","width":"20","height":"20","fill":"none","key":0}),React.createElement("path",{"id":"reply-r","d":"M11.162,4.17,1.8,11.034l9.364,8.119V14.782h1.71a4.971,4.971,0,0,1,3.276,1.232l3.6,3.149V14.778a6.392,6.392,0,0,0-6.392-6.392h-2.19Zm-1.42,2.8V9.806h3.61a4.971,4.971,0,0,1,4.971,4.971v1.253l-1.239-1.085a6.392,6.392,0,0,0-4.211-1.584H9.742v2.68L4.074,11.127Z","transform":"translate(-0.771 -1.746)","fill":"currentColor","fillRule":"evenodd","key":1})]);
}

LogOut.defaultProps = {"id":"log_out","width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = LogOut;

LogOut.default = LogOut;
